import request from '@/utils/httpRequest'

export default {
  save: function (inputForm) {
    return request({
      url: '/cecitem/cecItem/save',
      method: 'post',
      data: inputForm
    })
  },

  delete: function (ids) {
    return request({
      url: '/cecitem/cecItem/delete',
      method: 'delete',
      params: {ids: ids}
    })
  },

  queryById: function (id) {
    return request({
      url: '/cecitem/cecItem/queryById',
      method: 'get',
      params: {id: id}
    })
  },

  list: function (params) {
    return request({
      url: '/cecitem/cecItem/list',
      method: 'get',
      params: params
    })
  },

  parentList: function (params) {
    return request({
      url: '/cecitem/cecItem/parentList',
      method: 'get',
      params: params
    })
  },

  exportTemplate: function () {
    return request({
      url: '/cecitem/cecItem/import/template',
      method: 'get',
      responseType: 'blob'
    })
  },

  exportExcel: function (params) {
    return request({
      url: '/cecitem/cecItem/export',
      method: 'get',
      params: params,
      responseType: 'blob'
    })
  },

  importExcel: function (data) {
    return request({
      url: '/cecitem/cecItem/import',
      method: 'post',
      data: data
    })
  },

  getCecUpdateItem: function (params) {
    return request({
      url: '/cecitem/cecItem/getCecUpdateItem',
      method: 'post',
      params: params
    })
  }
}
